import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ChangeEvent, FunctionComponent, useState } from 'react';

type ResendActionProps = {
    onResend: (reason: string) => void;
    isLoading?: boolean;
    buttonLabel: string;
};

export const ResendAction: FunctionComponent<ResendActionProps> = ({
    onResend,
    isLoading = false,
    buttonLabel,
}) => {
    const [reason, setReason] = useState('');

    const onReasonChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        setReason(value);
    };

    return (
        <Stack direction='row' spacing={3} alignItems='flex-start'>
            <TextField
                label='Grund'
                value={reason}
                sx={{
                    width: 320,
                }}
                onChange={onReasonChange}
                helperText='Mindestens 10 Zeichen'
            />

            <LoadingButton
                disabled={reason.length < 10}
                variant='contained'
                loading={isLoading}
                onClick={() => {
                    onResend(reason);
                }}
            >
                {buttonLabel}
            </LoadingButton>
        </Stack>
    );
};
